import { GetProductsService } from '../services'

export default () => {
	return new Promise((resolve, reject) => {
		GetProductsService()
			.then(response => resolve({ success: true, data: response.data }))
			.catch(err => reject({ error: true }))
	})
}
